import { getEnvironment, ENVIRONMENTS } from '@olo-web/utils/common/functions/getEnvironment';
import { EFirestoreCollections } from '@olo-web/types/enums/firestoreCollections.enum';

export const getMerchantThemeCollectionName = (): string =>
  getEnvironment() === ENVIRONMENTS.PROD
    ? EFirestoreCollections.MERCHANT_THEME
    : EFirestoreCollections.MERCHANT_THEME_SNAPSHOT;
